import { kinds, kindNames } from 'schema';

export const getAdministratorKind = (typeName: string | undefined = '') => {
  const filterKind = kinds.filter((kind) => {
    return kind.replace(/_/g, '').toLowerCase() === typeName.replace(/ /g, '').toLowerCase() + 's';
  });
  return kindNames[filterKind[0]];
};
